<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-7"></a>
<h2 class="fm-head1"><strong class="b">Acknowledgements</strong></h2>
<p class="nonindent"><span class="dropcaps">W</span>e would like to thank the following people and organisations who have helped in completing this project:</p>
<p class="indent">The National Archives in Kew for providing documents relating to the Biggin Hill Experiment and other documents which helped fill in gaps about Arthur’s later service history in Ceylon and India during the war.</p>
<p class="indent">The Imperial War Museum, for its excellent photo library, which produced some new photos.</p>
<p class="indent">Duxford Museum, particularly the helpful volunteer tour guide Graham Rogers, who gave the family a wonderful tour, and its historian Carl Warner.</p>
<p class="indent">Our editor, Richard Doherty, for being so knowledgeable about the historical details.</p>
<p class="indent">Arthur’s wife, Mary, for her informative letters about Arthur’s time as Commander in Chief of the Pakistan Air Force.</p>
<p class="indent">The book, <em class="i">Tizzard</em> by Ronald W. Clark, which gives a helpful account of the events leading up to the Biggin Hill Experiment.</p>
<p class="indent">Graham Clarke, the historian of the Royal Lymington Yacht Club, for taking the time to send us details of Arthur’s sailing achievements.</p>
<p class="indent">Phil Listemann, who runs the excellent website, RAF-in-Combat, who spent time looking through his vast photo collection to find photos of relevant planes.</p>
<p class="indent">Particular thanks also go to Robin and Ian McDonald for their help in providing photos and information for the Antigua sections of the book.</p>
<p class="indent">We would also like to thank family members in the UK, particularly Jean, John, Peter, Ian, Alison, Simon, Joe and Jez who all helped provide extra details for the book and helped with proof reading.</p>
<p class="indent">The family also gained useful information visiting the new museum at Biggin Hill and the excellent Battle of Britain Bunker at Uxbridge when researching the book.</p>
<a id="VPS-8"></a>
<p class="indent">Unless otherwise stated, all images have been provided from Arthur’s own collection. Many of the RAF photos contained in Arthur’s collection were taken by official RAF photographers and were under Crown Copyright until this expired.</p>
<p class="indent">These memoirs were completed by Arthur’s oldest daughter Ann and granddaughter Jackie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Acknowledgement.vue?c82d1a16